import { Button } from '@mui/material';
import { styled } from '@mui/system';

export const StyledBackButton = styled(Button)({
  textTransform: 'uppercase',
  color: '#302f2e',
  fontFamily: 'Oswald',
  border: '1px solid #302f2e',
  borderRadius: 0,
});
